import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import {
    useForm,
    Controller,
    useFieldArray,
} from "react-hook-form";
import { toast } from "react-toastify";
import { FaPlus, FaMinus } from "react-icons/fa";

import TopHeader from "../../Components/TopHeader";
import Prince from "../../Components/Prince";

// SERVICES
import * as b2cLeadService from "../../Services/b2cleadService";

const B2cContact = () => {

    const navigate = useNavigate();

    const { id } = useParams();

    const [partner, setPartner] = useState({});

    const [departmentOptions, setDepartmentOptions] = useState([]);

    const [designationOptions, setDesignationOptions] = useState([]);

    const [loading, setLoading] = useState(false);

    const {
        register,
        handleSubmit,
        control,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm({
        defaultValues: {
            contacts: [
                {
                    fullName: "",
                    email: "",
                    mobile: "",
                    department: null,
                    designation: null,
                    id: "",
                },
            ],
        },
    });

    const {
        fields,
        append,
        remove,
    } = useFieldArray({
        control,
        name: "contacts",
    });

    // GET PARTNER DETAILS
    const getPartnerDetails = async () => {

        try {

            const response =
                await b2cLeadService.getLeadContact(id);

            if (response?.data?.data) {

                const partnerData = response.data.data;

                setPartner(partnerData);

                if (
                    partnerData?.ContactInfo &&
                    partnerData.ContactInfo.length > 0
                ) {

                    const formattedContacts =
                        partnerData.ContactInfo.map((contact) => ({
                            fullName: contact.name || "",
                            email: contact.email || "",
                            mobile: contact.mobile || "",
                            department: contact.department
                                ? {
                                    value: contact.department,
                                    label: contact.department,
                                }
                                : null,
                            designation: contact.designation
                                ? {
                                    value: contact.designation,
                                    label: contact.designation,
                                }
                                : null,
                            id: contact.id || "",
                        }));

                    reset({
                        contacts: formattedContacts,
                    });

                }

            }

        } catch (error) {

            console.log(error);

        }

    };

    // GET DEPARTMENT
    const getDepartment = async () => {

        try {

            const response =
                await b2cLeadService.getAllMasterData(7);

            if (
                response?.data?.data &&
                Array.isArray(response.data.data)
            ) {

                const options =
                    response.data.data.map((item) => ({
                        value: item.name,
                        label: item.name,
                    }));

                setDepartmentOptions(options);

            }

        } catch (error) {

            console.log(error);

        }

    };

    // GET DESIGNATION
    const getDesignation = async () => {

        try {

            const response =
                await b2cLeadService.getAllMasterData(6);

            if (
                response?.data?.data &&
                Array.isArray(response.data.data)
            ) {

                const options =
                    response.data.data.map((item) => ({
                        value: item.name,
                        label: item.name,
                    }));

                setDesignationOptions(options);

            }

        } catch (error) {

            console.log(error);

        }

    };

    useEffect(() => {

        getPartnerDetails();

        getDepartment();

        getDesignation();

    }, []);

    // SUBMIT
    const onSubmit = async (data) => {

        try {

            setLoading(true);

            const previousContact =
                data.contacts.map((item) => ({
                    name: item.fullName,
                    email: item.email,
                    mobile: item.mobile,
                    department:
                        item.department?.value || "",
                    designation:
                        item.designation?.value || "",
                    id: item.id || "",
                    leadId: id,
                }));

            const body = {
                previousContact:
                    JSON.stringify(previousContact),
            };

            const response =
                await b2cLeadService.createLeadContact(
                    id,
                    body
                );

            if (response?.data?.status === false) {

                toast.error(response.data.message);

                return;

            }

            toast.success(
                response?.data?.message ||
                "Contact Saved Successfully"
            );

            getPartnerDetails();

        } catch (error) {

            console.log(error);

            toast.error(
                error?.response?.data?.message ||
                "Something went wrong"
            );

        } finally {

            setLoading(false);

        }

    };

    return (

        <div className="page">

            <TopHeader />

            <Prince />

            <div className="container-fluid py-4">

                <div
                    className="card border-0 shadow-sm"
                    style={{
                        borderRadius: "18px",
                    }}
                >

                    <div className="card-body p-4">

                        {/* HEADER */}
                        <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">

                            <span className="badge bg-primary fs-6 px-3 py-2">
                                Contact Information
                            </span>

                        </div>

                        <div className="border-top my-3"></div>

                        {/* FORM */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                        >

                            {fields.map((field, index) => {

                                const currentRow =
                                    watch(`contacts.${index}`);

                                const isFilled =
                                    currentRow?.fullName ||
                                    currentRow?.email ||
                                    currentRow?.mobile ||
                                    currentRow?.department ||
                                    currentRow?.designation;

                                return (

                                    <div
                                        className="row g-4 align-items-start mb-3"
                                        key={field.id}
                                    >

                                        {/* FULL NAME */}
                                        <div className="col-12 col-md-6 col-lg-2">

                                            <label className="form-label fw-semibold">
                                                Full Name
                                            </label>

                                            <input
                                                type="text"
                                                className={`form-control ${errors?.contacts?.[index]?.fullName
                                                    ? "is-invalid"
                                                    : ""
                                                    }`}
                                                placeholder="Enter Full Name"
                                                {...register(
                                                    `contacts.${index}.fullName`,
                                                    {
                                                        required:
                                                            "Please enter full name",
                                                    }
                                                )}
                                            />

                                            {errors?.contacts?.[index]?.fullName && (
                                                <div className="invalid-feedback">
                                                    {
                                                        errors.contacts[index]
                                                            .fullName.message
                                                    }
                                                </div>
                                            )}

                                        </div>

                                        {/* EMAIL */}
                                        <div className="col-12 col-md-6 col-lg-2">

                                            <label className="form-label fw-semibold">
                                                Email
                                            </label>

                                            <input
                                                type="email"
                                                className={`form-control ${errors?.contacts?.[index]?.email
                                                    ? "is-invalid"
                                                    : ""
                                                    }`}
                                                placeholder="Enter Email"
                                                {...register(
                                                    `contacts.${index}.email`,
                                                    {
                                                        required:
                                                            "Please enter email",
                                                        pattern: {
                                                            value:
                                                                /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                            message:
                                                                "Please enter valid email",
                                                        },
                                                    }
                                                )}
                                            />

                                            {errors?.contacts?.[index]?.email && (
                                                <div className="invalid-feedback">
                                                    {
                                                        errors.contacts[index]
                                                            .email.message
                                                    }
                                                </div>
                                            )}

                                        </div>

                                        {/* MOBILE */}
                                        <div className="col-12 col-md-6 col-lg-2">

                                            <label className="form-label fw-semibold">
                                                Mobile
                                            </label>

                                            <input
                                                type="text"
                                                className={`form-control ${errors?.contacts?.[index]?.mobile
                                                    ? "is-invalid"
                                                    : ""
                                                    }`}
                                                placeholder="Enter Mobile"
                                                {...register(
                                                    `contacts.${index}.mobile`,
                                                    {
                                                        required:
                                                            "Please enter mobile number",
                                                        pattern: {
                                                            value:
                                                                /^[0-9]{10}$/,
                                                            message:
                                                                "Please enter valid mobile number",
                                                        },
                                                    }
                                                )}
                                            />

                                            {errors?.contacts?.[index]?.mobile && (
                                                <div className="invalid-feedback">
                                                    {
                                                        errors.contacts[index]
                                                            .mobile.message
                                                    }
                                                </div>
                                            )}

                                        </div>

                                        {/* DEPARTMENT */}
                                        <div className="col-12 col-md-6 col-lg-2">

                                            <label className="form-label fw-semibold">
                                                Department
                                            </label>

                                            <Controller
                                                name={`contacts.${index}.department`}
                                                control={control}
                                                rules={{
                                                    required:
                                                        "Please select department",
                                                }}
                                                render={({ field }) => (

                                                    <Select
                                                        {...field}
                                                        options={departmentOptions}
                                                        placeholder="Please Select"
                                                        isClearable={true}
                                                        classNamePrefix="react-select"
                                                    />

                                                )}
                                            />

                                            {errors?.contacts?.[index]?.department && (
                                                <small className="text-danger">
                                                    {
                                                        errors.contacts[index]
                                                            .department.message
                                                    }
                                                </small>
                                            )}

                                        </div>

                                        {/* DESIGNATION */}
                                        <div className="col-12 col-md-6 col-lg-3">

                                            <label className="form-label fw-semibold">
                                                Designation
                                            </label>

                                            <Controller
                                                name={`contacts.${index}.designation`}
                                                control={control}
                                                rules={{
                                                    required:
                                                        "Please select designation",
                                                }}
                                                render={({ field }) => (

                                                    <Select
                                                        {...field}
                                                        options={designationOptions}
                                                        placeholder="Please Select"
                                                        isClearable={true}
                                                        classNamePrefix="react-select"
                                                    />

                                                )}
                                            />

                                            {errors?.contacts?.[index]?.designation && (
                                                <small className="text-danger">
                                                    {
                                                        errors.contacts[index]
                                                            .designation.message
                                                    }
                                                </small>
                                            )}

                                        </div>

                                        {/* ADD REMOVE */}
                                        <div className="col-12 col-md-6 col-lg-1 d-flex align-items-end gap-2 mt-5">

                                            {/* ADD */}
                                            {index === fields.length - 1 &&
                                                fields.length < 10 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-success btn-sm"
                                                        onClick={() =>
                                                            append({
                                                                fullName: "",
                                                                email: "",
                                                                mobile: "",
                                                                department: null,
                                                                designation: null,
                                                                id: "",
                                                            })
                                                        }
                                                    >
                                                        <FaPlus />
                                                    </button>
                                                )}

                                            {/* REMOVE ONLY BLANK ROW */}
                                            {/* {fields.length > 1 &&
                                                !isFilled && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() =>
                                                            remove(index)
                                                        }
                                                    >
                                                        <FaMinus />
                                                    </button>
                                                )} */}

                                            {index >= partner?.ContactInfo?.length && (
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => remove(index)}
                                                >
                                                    <FaMinus />
                                                </button>
                                            )}

                                        </div>

                                    </div>

                                );

                            })}

                            {/* BUTTON */}
                            <div className="d-flex justify-content-end mt-5">

                                <button
                                    type="submit"
                                    className="btn btn-sm btn-primary rounded-pill px-4"
                                    disabled={loading}
                                >

                                    {loading
                                        ? "Saving..."
                                        : "Save"}

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>

            {/* FOOTER */}
            <div className="main-footer text-center">

                <div className="container">

                    <div className="col-md-12">

                        <span>
                            Copyright © 2024{" "}
                            <a href="">FSHIP</a>.
                            Developed by{" "}
                            <a href="http://fship.in/">
                                FSHIP
                            </a>{" "}
                            All rights reserved.
                        </span>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default B2cContact;